module.exports = __webpack_public_path__ + "img/message.60cbb0ac.svg";